module.exports = __webpack_public_path__ + "assets/scrollreveal.6564551a.svg";